import SideBarJPayPromo from "./SideBarJPayPromo";
import SideBarPickerPromo from "./SideBarPickerPromo";
import useShowPickerPromo from "../../PickerPromo/hooks/useShowPickerPromo";
import { useState } from "react";
import { useUser } from "contexts/userContext/userContext";
import useMediaQueries from "hooks/useMediaQueries";

interface ISidebarPromo {
  swapFormFunction: () => void;
  currentOption: string;
  collapsed: boolean;
}

const SideBarPromo = ({
  swapFormFunction,
  currentOption,
  collapsed,
}: ISidebarPromo) => {
  const [closed, setClosed] = useState(false);
  const { getUserData, getIsIsrael } = useUser();
  const { mobileCondition } = useMediaQueries();

  const hideJumbopay = !getIsIsrael() || getUserData().HideJumboPay;

  const jpayPromoCondition = !hideJumbopay && currentOption !== "pay-light";

  const { showPickerPromo } = useShowPickerPromo();

  if (closed || mobileCondition) return null;

  if (showPickerPromo)
    return <SideBarPickerPromo {...{ setClosed, collapsed }} />;

  if (jpayPromoCondition)
    return <SideBarJPayPromo {...{ swapFormFunction, collapsed, setClosed }} />;

  return null;
};

export default SideBarPromo;
